import { useEffect } from 'react';
import { usePostHogCapture } from '../integrations/posthog/usePostHogCapture';

export function AppReadyTracking() {
  const capture = usePostHogCapture();

  useEffect(() => {
    const loadTime = performance.now(); // Time since navigation start

    capture('app_ready', {
      load_time_ms: loadTime,
    });
  }, []);

  return null;
}
